/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Discord_Own_TInputs */



/**
* | output |
* | --- |
* | "Install the bot on your server" |
*
* @param {Tournament_Wiz_Tip_Discord_Own_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_discord_own_t = /** @type {((inputs?: Tournament_Wiz_Tip_Discord_Own_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Discord_Own_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Installez le bot sur votre serveur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Instale el bot en su servidor")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Instale o bot no seu servidor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Installa il bot sul tuo server")
	return /** @type {LocalizedString} */ ("Install the bot on your server")
});